module.exports = __webpack_public_path__ + "static/img/home_commission_3.0e0ff0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_commission_3.png
// module id = OK2V
// module chunks = 0